export type ImageSize = 'large' | 'medium' | 'small' | 'thumbnail' | 'appleTouchIcon';

export interface ContentApiImage {
  url?: string;
  formats?: { [key in ImageSize]?: { url?: string } };
}

/**
 * Takes a Strapi image with
 * a formats property. Returns
 * the default URL if format isn't defined
 */

export function getImageFormatUrl(
  image?: ContentApiImage | null,
  desiredSize: ImageSize = 'large'
) {
  if (!image) return undefined;
  const formatImg = image.formats?.[desiredSize]?.url;
  if (formatImg) return formatImg;

  return image?.url;
}

export interface ExtractBannerImageOptions {
  previewBannerImage?: string | null;
  contentApiImage?: ContentApiImage | null;
  externalBannerImage?: string | null;
  imageSize?: ImageSize;
}

/**
 * All of our domain objects
 * can have either a `bannerImage`
 * or an `externalBannerImage`
 * property. This function
 */
export function extractBannerImage({
  contentApiImage,
  externalBannerImage,
  previewBannerImage,
  imageSize = 'large',
}: ExtractBannerImageOptions) {
  return (
    previewBannerImage || getImageFormatUrl(contentApiImage, imageSize) || externalBannerImage || ''
  );
}
